import { render, staticRenderFns } from "./role-edit.vue?vue&type=template&id=426c0516&scoped=true"
import script from "./role-edit.vue?vue&type=script&lang=js"
export * from "./role-edit.vue?vue&type=script&lang=js"
import style0 from "./role-edit.vue?vue&type=style&index=0&id=426c0516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426c0516",
  null
  
)

export default component.exports